/* sd-cosmic.js — starfield background + scroll-reveal.
   Ported from Copy of Debut cosmic.js. No dependencies. Respects reduced motion. */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Scroll reveal ---- */
  function initReveal() {
    var nodes = document.querySelectorAll('.sd-reveal');
    if (!nodes.length) return;
    if (reducedMotion || !('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('sd-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('sd-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    nodes.forEach(function (n) { io.observe(n); });
  }

  /* ---- Starfield ---- */
  function initStars() {
    if (reducedMotion) return;
    var canvas = document.createElement('canvas');
    canvas.id = 'sd-stars';
    canvas.setAttribute('aria-hidden', 'true');
    document.body.prepend(canvas);

    var ctx = canvas.getContext('2d');
    var stars = [];
    var COUNT = 140;

    function resize() {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    }

    function seed() {
      stars = [];
      for (var i = 0; i < COUNT; i++) {
        stars.push({
          x: Math.random() * canvas.width,
          y: Math.random() * canvas.height,
          r: Math.random() * 1.3 + 0.2,
          p: Math.random() * Math.PI * 2,
          s: 0.004 + Math.random() * 0.01
        });
      }
    }

    function frame() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      for (var i = 0; i < stars.length; i++) {
        var st = stars[i];
        st.p += st.s;
        var a = 0.35 + Math.sin(st.p) * 0.3;
        ctx.beginPath();
        ctx.arc(st.x, st.y, st.r, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(242, 240, 254,' + a.toFixed(3) + ')';
        ctx.fill();
      }
      requestAnimationFrame(frame);
    }

    resize();
    seed();
    frame();
    window.addEventListener('resize', function () { resize(); seed(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initReveal(); initStars(); });
  } else {
    initReveal();
    initStars();
  }
})();
